export const getUnixDate = (dt: any) => Math.floor(new Date(dt).getTime() / 1000);
export const getDateFromUnix = (dt: number) => new Date(dt * 1000);
